import { Injectable } from '@angular/core';
import { User } from './login-form/user.model';
import { StorageKeys } from '../Shared/Constant/StorageKeys'
import { APIURL } from '../Shared/Constant/API_Urls';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { Router } from '@angular/router';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { MessageService } from 'primeng/api';
import { first, Observable, of } from 'rxjs';
@Injectable(
    { providedIn: 'root' }
)
export class AuthServiceService {
    private isUserLoggedIn = false;
    mpid: any = "RSMS";
    session: any;
    mpiddata: any;
    error: any;
    loading: boolean = false;
    rememberDevice: boolean = false;
    headers = new HttpHeaders();

    constructor(private http: HttpClient,
        private sharedHttpClientService: SharedHttpClientService,
        private router: Router,
        private userService: UserService,
        public urlsService: UrlsService,
        private messageService: MessageService,
        public constantService: ConstantService,) {
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Access-Control-Allow-Headers', 'Authorization');
    }

    setToken(result: any) {
        this.loading = true;
        this.setUserLoggedIn();
        // login successful
        if (result?.tokens) {
            let tokens: any = result.tokens
            this.constantService.setSessionStorage(StorageKeys.jwtToken, tokens['AccessToken'], 1);
            this.constantService.setSessionStorage(StorageKeys.idToken, tokens['IdToken'], 1);
            this.constantService.setSessionStorage(StorageKeys.refreshToken, tokens['RefreshToken'], 1);

            const deviceMeta = result?.tokens?.NewDeviceMetadata;
            if(this.rememberDevice){
                let payload = {
                    "accessToken":this.constantService.getSessionStorage(StorageKeys.jwtToken),
                    "username":this.constantService.user.email,
                    "deviceKey":deviceMeta?.DeviceKey,
                    "deviceGroupKey":deviceMeta?.DeviceGroupKey,
                    "deviceName":this.constantService.getDeviceName()
                }

                this.confirmDevice(payload)
                .pipe(first())
                    .subscribe({
                        next: (result: any) => {
                            
                            if (result?.success) {
                            // store locally for 30 days
                            let updateDeviceMeta:any ={};
                                if (result?.devicePassword) {
                                    updateDeviceMeta = {
                                        "deviceKey": deviceMeta?.DeviceKey,
                                        "deviceGroupKey": deviceMeta?.DeviceGroupKey,
                                        "devicePassword": result?.devicePassword,
                                        "deviceName": this.constantService.getDeviceName()
                                    }
                                    this.constantService.setCookie(this.constantService.user.email, JSON.stringify(updateDeviceMeta), 30);
                                    this.messageService.add({ severity: 'info', summary: 'Message', detail: result?.message });
                                }  
                        } 
                        },
                        error: (err: HttpErrorResponse) => {
                            this.constantService.deleteCookies(this.constantService.user.email);
                            this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: err?.error?.message || "Something went wrong." });
                        }
                    });
            }

            /*set MPID LocalStore  */
            this.getMPIDList(this.constantService.user.email, this.mpid, false);

        } else {
            this.error = "Something went wrong."
            this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: this.error });
        }
    }


    mfa_addUser(payload: any) {
        return this.sharedHttpClientService.post(APIURL.mfa_host + APIURL.mfa_add_new_user, payload)
    }

    mfa_updateUser(payload: any) {
        return this.sharedHttpClientService.post(APIURL.mfa_host + APIURL.mfa_update_user, payload)
    }

    mfa_activateUser(payload: any) {
        return this.sharedHttpClientService.post(APIURL.mfa_host + APIURL.mfa_activate_user, payload)
    }

    mfa_deactivateUser(payload: any) {
        return this.sharedHttpClientService.post(APIURL.mfa_host + APIURL.mfa_deactivate_user, payload)
    }

    mfa_deleteUser(payload: any) {
        return this.sharedHttpClientService.post(APIURL.mfa_host + APIURL.mfa_delete_user, payload)
    }

    mfa_login(user: User) {
        return this.http.post(APIURL.mfa_host + APIURL.mfa_login, user, { headers: this.headers, responseType: 'json', observe: 'body' })
    }

    mfa_logout(userName:any): Observable<any> {
        console.log("logout user:",userName)

        if (userName) {
            let payload = {
               "username": userName,
               "deviceName": this.constantService.getDeviceName()
            }
         return   this.http.post(APIURL.mfa_host + APIURL.mfa_logout, payload, { headers: this.headers, responseType: 'json', observe: 'body' })
        }
         return of(null); 
    }

    verifyOtp(payload: any) {
        return this.http.post(APIURL.mfa_host + APIURL.mfa_aws_verify_otp, payload, { headers: this.headers, responseType: 'json', observe: 'body' })
    }

    setNewPassword(payload: any) {
        return this.http.post(APIURL.mfa_host + APIURL.mfa_set_new_password, payload, { headers: this.headers, responseType: 'json', observe: 'body' })
    }

    forgotPassword(payload: any) {
        return this.http.post(APIURL.mfa_host + APIURL.mfa_reset_password, payload, { headers: this.headers, responseType: 'json', observe: 'body' })
    }

    confirmPassword(payload: any) {
        return this.http.post(APIURL.mfa_host + APIURL.mfa_confirm_rest_password, payload, { headers: this.headers, responseType: 'json', observe: 'body' })
    }

    confirmDevice(payload: any) {
        return this.http.post(APIURL.mfa_host + APIURL.mfa_confirm_device, payload, { headers: this.headers, responseType: 'json', observe: 'body' })
    }

    logout(): void {
        // clear token remove user from local storage to log user out
        sessionStorage.removeItem(StorageKeys.User);
        localStorage.clear();
        sessionStorage.clear();
    }


    getMPIDList(name: string, mpid: any, isPasswordExpired: boolean): any {
        this.loading = true;
        this.sharedHttpClientService.get(
            APIURL.host + APIURL.project_name + mpid + "/" +
            APIURL.MPIDList +
            name +
            "/")
            .pipe(first())
            .subscribe({
                next: (data: any) => {
                        this.loading = false;
                        this.mpiddata = data;
                        let mpidList: any = this.mpiddata[0]?.mpid;
                        this.urlsService.MPID = mpidList[0]?.mpid;
                        this.constantService.setSessionStorage(StorageKeys.User,
                            JSON.stringify({
                                username: name,
                                userFirstName: this.mpiddata[0]?.userName,
                                mpid: this.mpiddata
                            }), 1);
                        this.constantService.setSessionStorage(StorageKeys.MPID,
                            JSON.stringify({
                                defaultMPID: mpidList[0]?.mpid,
                            }), 1);
                        this.userService.init();
                        this.setUserLoggedIn()
                        let homeurl = '/pages/MainDashboard/';
                        this.router.navigate([homeurl]);
              },
                error: (err: HttpErrorResponse) => {
                    this.loading = false;
                    if (err.status === 400) {
                        this.error = "Invalid JWT or expired code.";
                    } else if (err.status === 401) {
                        this.error = "Invalid JWT or Session expired. Please login again.";
                    } else {
                        this.error = err?.error?.message || "Something went wrong.";
                    }
                    this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: this.error });
                    return false;
                }
            });

    }



    setUserLoggedIn() {
        this.isUserLoggedIn = true;
    }

    getUserLoggedIn() {
        return this.isUserLoggedIn;
    }
}